import React, { useState, useRef } from 'react';
import { FiSearch } from 'react-icons/fi';
import { useIntl } from 'react-intl';
import useUserKeyPress from 'helpers/useUserKeyPress';
import messages from './messages';

let focused = false;

const Search = ({
  params,
  setParams,
  isMain,
  setInclude,
  disableSearchFocus
}) => {
  const [delay, setDelay] = useState('');
  const inputRef = useRef(null);
  const { formatMessage } = useIntl();

  useUserKeyPress(27, e => {
    e.preventDefault();
    inputRef.current.blur();
  });

  useUserKeyPress(191, e => {
    if (!disableSearchFocus && !focused) {
      e.preventDefault();
      inputRef.current.focus();
      focused = true;
    }
  });

  const handleChange = e => {
    let text = e.target.value;
    if (delay) clearTimeout(delay);
    let copyState = delay;
    copyState = setTimeout(() => {
      if (!text.length) {
        const { search: tmp, ...rest } = params;
        setParams(rest);
        if (isMain) setInclude('?include=all_subcategories&main=1');
      } else {
        if (isMain) {
          setInclude('');
          const { main: rmv, ...rest2 } = params;
          setParams({ ...rest2, search: text });
        } else {
          setParams({ ...params, search: text });
        }
      }
    }, 500);
    setDelay(copyState);
  };

  return (
    <div className="search_holder">
      <FiSearch />
      <input
        type="search"
        placeholder={formatMessage(
          disableSearchFocus ? messages.search : messages.search_placeholder
        )}
        onChange={handleChange}
        ref={inputRef}
        onFocus={() => (focused = true)}
        onBlur={() => (focused = false)}
      />
    </div>
  );
};

export default Search;
